<script setup lang="ts">
const route = useRoute();

const cleanedRoute = computed(() => {
  const { params, ...rest } = route;
  return {
    ...rest,
    path: route.path
      .split("/")
      .filter((segment) => !Object.values(params).includes(segment))
      .join("/"),
  };
});

const injected = inject<{ routeMetaChildTitle: string }>("routeMetaChildTitle");
const routeMetaChildTitle = injected ? injected.routeMetaChildTitle : "";
</script>

<template>
  <header>
    <!-- <header class="h-[76px]"> -->
    <!-- <div class="z-1 t-0 fixed left-[307px] right-2 ml-2 bg-primary pt-2"> -->
    <!-- <div
        class="flex items-center justify-between rounded-t-lg bg-surface-100 px-8 pt-8"
      > -->
    <!-- https://codepen.io/harshboricha98/pen/zYdoXpo -->
    <div class="flex items-center justify-between bg-surface-100">
      <div class="flex items-center gap-2">
        <NuxtLink :to="cleanedRoute.path">
          <h1 class="mr-auto text-lg font-medium text-surface-900 md:text-xl">
            {{ route.meta.title }}
          </h1>
        </NuxtLink>

        <ChevronRight v-if="Object.keys(route.params).length" />

        <h2
          v-if="Object.keys(route.params).length"
          class="mr-auto text-lg font-medium text-surface-900 md:text-xl"
        >
          {{ routeMetaChildTitle }}
        </h2>
      </div>

      <div class="flex items-center">
        <PanelNotificationsIcon class="mr-3 hidden xl:block" />
        <PanelAvatar class="hidden xl:block" />
      </div>
    </div>
    <!-- </div> -->
  </header>
</template>
